var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"remember-success"},[_c('h3',[_vm._v("Проверьте почту!")]),_vm._v(" "),_c('h5',[_vm._v("Мы отправили вам новый пароль")]),_vm._v(" "),_c('img',{attrs:{"src":"/v2/auth/remember-success.png","alt":"success"}})])
}]

export { render, staticRenderFns }